import { useEffect, useState } from 'react';
import { winnreAuth } from '../utils/axios';
import { scrollToTargetAdjusted } from '../utils/ui';
import {
    useHistory,
    useLocation
} from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from 'react-redux';

import { dealAction } from '../store/deal-slice';

import { getConfig } from '../utils/config';

const useKYC = () => {
    const [step, setStep] = useState(1);
    const dispatch = useDispatch();
    const [isKycCompleted, setKycCompleted] = useState(false);
    const [isKycProcessing, setIsKycProcessing] = useState(false);
    const [claimInProgress, setClaimInProgress] = useState(false);
    const [error, setError] = useState(null);
    const [showError, setShowError] = useState(false);
    const [isUpdateWorkflow, setUpdateWorkflow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openKYCModal, setOpenKYCModal] = useState(false);
    const [cashOutFlow, setCashOutFlow] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location?.search);
    const status = queryParams.get('status');
    const process = queryParams.get('process');
    const moveToBankVerification = queryParams.get('cashOut');
    const rewardTypeSelected = queryParams.get('rewardTypeSelected');
    const utm_campaign = queryParams.get('utm_campaign');
    const rewardFormCompleted = utm_campaign === 'MVouchersReferral';
    const [bankstatus, setBankStatus] = useState('');
    const [isKycFailed, setIsKycFailed] = useState(false);
    const [isBankVerificationFailed, setIsBankVerificationFailed] =
        useState(false);

    const config = getConfig();
    const history = useHistory();

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowError(false);
        }, 3000);

        return () => {
            clearTimeout(timer);
        };
    }, [showError]);

    useEffect(() => {
        console.log(rewardFormCompleted);
        if (!!rewardFormCompleted) {
            winnreAuth({
                method: 'POST',
                url: '/winnre/user/customer/claim-rewards'
            }).then((res) => {
                // console.log('CLAIM REWARD', res);
                if (res?.status == 'FAILED') {
                    setStep(2); // Add code what happens if req fails
                    return;
                }
                setOpenKYCModal(true);
                setKycCompleted(true);
                setStep(2);
            });
        }
    }, [rewardFormCompleted]);

    useEffect(() => {
        // initiateWorkflow('BANK_ACCOUNT_VERIFICATION');
        // initiateWorkflow('DIGILOCKER');

        //FOR UPDATE + CONFIRM SCREEN
        // setOpenKYCModal(true);
        // setStep(3);
        // console.log('MUSKAY', rewardFormCompleted);

        if (!!rewardFormCompleted) {
            return;
        }

        if (status === 'success' && process === 'DIGILOCKER') {
            winnreAuth({
                method: 'GET',
                url: `/winnre/user/user/kyc-status?refresh=true`
            }).then((res) => {
                console.log(res);

                if (res?.message === 'COMPLETED') {
                    if (moveToBankVerification == 'true') {
                        setCashOutFlow(true);
                        checkBankVerificationStatus({ kycStatus: 'COMPLETED' });
                        return;
                    } else {
                        setStep(7);
                        setOpenKYCModal(true);
                        return;
                    }
                } else if (res?.message === 'FAILED') {
                    setKycCompleted(false);
                    setIsKycFailed(true);
                    setOpenKYCModal(true);
                    setClaimInProgress(false);
                    setStep(1);
                    return;
                } else {
                    return winnreAuth({
                        method: 'POST',
                        url: `/winnre/user/change-kyc-status?status=PROCESSING`
                    }).then((res) => {
                        console.log(
                            'Processing inside process Digilocker ',
                            res
                        );

                        if (moveToBankVerification == 'true') {
                            setCashOutFlow(true);
                            checkBankVerificationStatus({
                                kycStatus: 'PROCESSING'
                            });
                            return;
                        } else {
                            console.log(
                                'isKycProcessing state inside processing api call'
                            );
                            setKycCompleted(true);
                            setIsKycProcessing(true);
                            setClaimInProgress(true);
                            setStep(2);
                            setOpenKYCModal(true);
                        }
                    });
                }
            });
        }

        // if (status === 'success' && process === 'BANK_ACCOUNT_VERIFICATION') {
        //     winnreAuth({
        //         method: 'GET',
        //         url: `/winnre/user/bank-account/verification-status`
        //     }).then((res) => {
        //         console.log(res);

        //         if (res?.message === 'COMPLETED') {
        //             setStep(5);
        //         } else if (res?.message === 'FAILED') {
        //             setKycCompleted(true);
        //             setIsBankVerificationFailed(true);
        //             setOpenKYCModal(true);
        //             setClaimInProgress(false);
        //             setStep(1);
        //             return;
        //         } else {
        //             setLoading(true);
        //             return winnreAuth({
        //                 method: 'POST',
        //                 url: `/winnre/user/bank-account/change-verification-status?status=PROCESSING`
        //             }).then((res) => {
        //                 console.log(res);
        //                 //  setStep(5);
        //                 setIsKycProcessing(false);
        //                 setStep(2);
        //                 setLoading(false);
        //             });
        //         }
        //     });
        //     setOpenKYCModal(true);
        //     setClaimInProgress(true);
        // }
        if (status === 'success' && process === 'BANK_ACCOUNT_VERIFICATION') {
            winnreAuth({
                method: 'GET',
                url: `/winnre/user/bank-account/verification-status`
            }).then((res) => {
                console.log(res);

                if (res?.message === 'FAILED') {
                    // Handle the failure case
                    setKycCompleted(true);
                    setIsBankVerificationFailed(true);
                    setOpenKYCModal(true);
                    setClaimInProgress(false);
                    setStep(1);
                    return;
                } else {
                    // For all other statuses (e.g., COMPLETED, PROCESSING), set step 5
                    setStep(5);
                }
            });

            // Open the KYC modal and set claim progress
            setOpenKYCModal(true);
            setClaimInProgress(true);
        }
    }, [process]);

    // console.log("Check Kyc Processing status inside useKyc" , isKycProcessing);

    useEffect(() => {
        if (rewardTypeSelected) {
            setStep(3);
            setOpenKYCModal(true);
        }
    }, [rewardTypeSelected]);

    const checkKycVerificationStatus = (
        forceInitate,
        silentCheck,
        cashoutProcess
    ) => {
        setLoading(true);
        setUpdateWorkflow(!!forceInitate);
        setCashOutFlow(!!cashoutProcess);
        winnreAuth({ method: 'GET', url: `/winnre/user/user/kyc-status` })
            .then((res) => {
                console.log('kyc', res);
                let data = 'COMPLETED';
                setLoading(false);

                // this condition is not supposed to be used
                if (res?.status === 'FAILED' && false) {
                    // setLoading(false);
                    setError(res?.message);
                } else {
                    if (res?.message === 'FAILED') {
                        setKycCompleted(false);
                        setClaimInProgress(false);
                        setIsKycFailed(true);
                        // setStep(6);
                        setStep(1);
                        return;
                    }
                    if (res?.message == 'COMPLETED' && !forceInitate) {
                        setKycCompleted(true);
                        if (config?.manuallySelectReward && !cashoutProcess) {
                            setStep(2);
                            return;
                        }
                        checkBankVerificationStatus({});
                    } else if (
                        res?.message == 'NOT_INITIATED' ||
                        res?.message == 'INITIATED' ||
                        res?.message === 'null' ||
                        //    (res?.message === 'FAILED' && !config?.KycAndBankStatusCheckScreen)||
                        forceInitate
                    ) {
                        if (silentCheck) {
                            setStep(1);
                            return;
                        }
                        setKycCompleted(false);
                        setClaimInProgress(false);
                        setStep(1);
                    } else if (res?.message == 'PROCESSING') {
                        setKycCompleted(true);
                        setIsKycProcessing(true);
                        if (config?.manuallySelectReward && !cashoutProcess) {
                            setClaimInProgress(true);
                            setStep(2);
                            return;
                        }
                        checkBankVerificationStatus({
                            kycStatus: 'PROCESSING'
                        });
                    } else {
                        setError(
                            'Something went wrong during KYC verification. Please try again after sometime'
                        );
                    }
                }
            })
            .catch((err) => {
                // console.log(err);
                setLoading(false);
                setError(
                    'Something went wrong during KYC verification. Please try again after sometime'
                );
            });
    };

    const checkBankVerificationStatus = ({ forceInitate, kycStatus }) => {
        setUpdateWorkflow(!!forceInitate);
        setLoading(true);
        winnreAuth({
            method: 'GET',
            url: `/winnre/user/bank-account/verification-status`
        })
            .then((res) => {
                console.log('bank', res);
                setLoading(false);
                // this condition is not supposed to be used
                if (res?.status === 'FAILED' && false) {
                    setLoading(false);
                    setError(res?.message);
                } else {
                    let data = 'FAILED';
                    if (res?.message === 'FAILED') {
                        setIsBankVerificationFailed(true); // Set Bank Verification failure state
                        setKycCompleted(true);
                        setOpenKYCModal(true);
                        setClaimInProgress(false);
                        // setStep(6);
                        setStep(1);
                        // setLoading(false);
                        return;
                    }
                    if (res?.message == 'COMPLETED' && !forceInitate) {
                        if (kycStatus == 'PROCESSING') {
                            setClaimInProgress(true);
                            setStep(2);
                            setOpenKYCModal(true);
                            return;
                        } else {
                            setBankStatus(res?.message);
                            setClaimInProgress(false);
                            // setStep(3);
                            setStep(0);
                            setOpenKYCModal(true);
                            return;
                        }
                    } else if (
                        res?.message == 'NOT_INITIATED' ||
                        res?.message == 'INITIATED' ||
                        res?.message === 'null' ||
                        // (res?.message === 'FAILED' && !config?.KycAndBankStatusCheckScreen)||
                        forceInitate
                    ) {
                        if (kycStatus == 'PROCESSING') {
                            setIsKycProcessing(true);
                        }
                        setBankStatus('');
                        setKycCompleted(true);
                        setOpenKYCModal(true);
                        setClaimInProgress(false);
                        setStep(1);
                        setLoading(false);
                        return;
                    } else if (res?.message == 'PROCESSING') {
                        setIsKycProcessing(false);
                        setLoading(false);
                        setClaimInProgress(true);
                        setOpenKYCModal(true);
                        setStep(2);
                    } else {
                        setError(
                            'Something went wrong during bank verification. Please try again after sometime'
                        );
                        setLoading(false);
                    }
                }
            })
            .catch(() => {
                setLoading(false);
                setError('Something went wrong during bank verification');
            });
    };

    console.log('bankStatus state', bankstatus);

    const initiateWorkflow = (type) => {
        // console.log('Initiate workflow called');
        setLoading(true);
        winnreAuth({
            method: 'POST',
            url: `/winnre/user/kyc/initiate-workflow?workflowType=${type}`
        })
            .then((res) => {
                console.log('initiate workflow', res);
                const link = `${window.location.href.split('?')[0]}?process=`;
                if (res?.status === 'FAILED') {
                    setLoading(false);
                    setError(res?.message);
                    setShowError(true);
                } else if (!res.id) {
                    setLoading(false);
                    setError(
                        `Something went wrong during ${
                            type == 'DIGILOCKER' ? 'KYC' : 'bank verification'
                        } initiation. Please try again later`
                    );
                    return;
                }
                const digioOptions = {
                    // trigger env to production for prod deployments
                    environment:
                        winnreAuth.defaults.baseURL ===
                        'https://prod.loyalie.in'
                            ? 'production'
                            : 'sandbox',
                    is_redirection_approach: true, //for redirection
                    is_iframe: false,
                    redirect_url: link + type + '&cashOut=' + cashOutFlow,
                    logo:
                        config?.logoLeft?.url ||
                        config?.logo?.url ||
                        'https://reloydev.s3.ap-south-1.amazonaws.com/Website/Uploads/Loyalie/Images/27822817.png',
                    theme: {
                        primaryColor: config?.primaryColor,
                        secondaryColor: '#000000'
                    }
                };

                const digio = new window.Digio(digioOptions);
                digio.init();
                // console.log(res.id, res.customer_identifier, res?.access_token?.id)
                digio.submit(
                    res.id,
                    res.customer_identifier,
                    res?.access_token?.id
                );
            })
            .catch((err) => {
                // console.log(err);
                setLoading(false);
                setError(
                    `Something went wrong during ${
                        type == 'DIGILOCKER' ? 'KYC' : 'bank verification'
                    } initiation`
                );
            });
    };

    const closeKYCModal = () => {
        setStep(1);
        setError(null);
        setKycCompleted(false);
        dispatch(dealAction.setKycModalEnabled(false));
        setClaimInProgress(false);
        setOpenKYCModal(false);
        setIsKycProcessing(false);
        setIsKycFailed(false); // Reset KYC failure state
        setIsBankVerificationFailed(false); // Reset Bank Verification failure state
        // getUserAccountSummary();
    };

    return {
        step,
        setStep,
        setError,
        error,
        showError,
        closeKYCModal,
        setOpenKYCModal,
        openKYCModal,
        loading,
        checkBankVerificationStatus,
        isUpdateWorkflow,
        isKycCompleted,
        initiateWorkflow,
        claimInProgress,
        rewardTypeSelected,
        checkKycVerificationStatus,
        cashOutFlow,
        setClaimInProgress,
        rewardFormCompleted,
        bankstatus,
        isKycFailed,
        isBankVerificationFailed,
        isKycProcessing
    };
};

export default useKYC;
